module.exports = __webpack_public_path__ + "img/image25.e65b1f29.jpg";